import styled from "styled-components";

export const StyledAddCertificationModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 60vw;

  & .form-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;
    row-gap: 20px;
    gap: 20px;

    & > section {
      max-width: 380px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
      grid-template-columns: 1fr;
      gap: 0px;

      & > section {
        max-width: unset;
      }
    }
  }

  & .space {
    margin-bottom: 200px;
  }

  & .visible {
    display: grid;
  }

  & .hidden {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.LG - 1}px) {
    width: 100%;
  }
`;

export const StyledAlertMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
    & span {
      font-size: 9px;
    }
  }
`;
